import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {MainComponent} from "./main/main.component";

const routes: Routes = [
  {path: '', redirectTo: 'main', pathMatch: 'full'},
  { path: '**', component: MainComponent }
];

@NgModule ({
  imports: [
    RouterModule.forRoot(routes, {useHash: true})
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts